import { render, staticRenderFns } from "./DashboardProjects.vue?vue&type=template&id=793a9d0e&scoped=true"
import script from "./DashboardProjects.vue?vue&type=script&lang=ts"
export * from "./DashboardProjects.vue?vue&type=script&lang=ts"
import style0 from "./DashboardProjects.vue?vue&type=style&index=0&id=793a9d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a9d0e",
  null
  
)

export default component.exports